export enum AsyncStatus {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    PARTIAL = 'PARTIAL',
    DONE = 'DONE',
    ERROR = 'ERROR',
}
